export default __webpack_public_path__ + "static/media/avatarwoman2.85dec98a.png";